<template>
  <div class="bg-light pt-5 pb-5">
    <div class="container">
      <div class="col-lg-8">
        <div class="bg-white round-10 ps-3 pe-3 pt-5 pb-5">
          <!--Mode livraison -->

          <div class="d-flex justify-content-between">
            <p class="font-18 font-bold blue-color">
              Pour élargir votre recherche, indiquez un nouveau code postal
            </p>
            <div class="search-block w-50">
              <form>
                <input type="text" class="form-control" id="search" placeholder="12345" v-only-digits />
                <button class="search-btn">
                  <i class="ti ti-search"></i>
                </button>
              </form>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-lg-12">
              <div class="d-flex justify-content-between">
                <form class="w-100">
                  <label
                    v-for="(point, index) in pointsRelais"
                    :key="index"
                    class="adress-box w-100"
                    :class="{
                      selected: selectedPoint === point.id,
                    }"
                  >
                    <input
                      type="radio"
                      :value="point.id"
                      v-model="selectedPoint"
                      name="pointRelais"
                      class="radio-hidden"
                    />
                    <div class="adress-box-left d-flex justify-content-between">
                      <div class="adress-box-info">
                        <h4>L’ADRESSE SAINE</h4>
                        <p>{{ point.adresse }}</p>
                        <button class="btn btn-outline-orange">Je choisis ce point relais</button>
                        <strong class="d-block"
                          >à
                          {{ point.distance }}
                          km</strong
                        >
                      </div>
                      <div class="adress-box-time">
                        <h4>HORAIRES D’OUVERTURE</h4>

                        <div v-for="(horaire, jour) in point.horaires" :key="jour">
                          <p class="d-flex justify-content-between">
                            <span>
                              {{ jour }}
                            </span>
                            <span> : {{ horaire }} </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="adress-box-right">
                      <div class="map">
                        <iframe
                          :src="point.map"
                          width="600"
                          height="450"
                          style="border: 0"
                          allowfullscreen=""
                          loading="lazy"
                          referrerpolicy="no-referrer-when-downgrade"
                        ></iframe>
                      </div>
                    </div>
                  </label>
                </form>
              </div>
            </div>
          </div>

          <!--Mode livraison -->

          <!--Mode de paiement-->

          <div class="mode-paiement">
            <label
              v-for="mode in modes"
              :key="mode.id"
              class="mode-box"
              :class="{ selected: selectedMode === mode.id }"
            >
              <input type="radio" name="modePaiement" class="radio-hidden" :value="mode.id" v-model="selectedMode" />

              <div class="mode-left">
                <div class="radio-visible">
                  <!-- Cercle radio stylisé -->
                  <div
                    class="circle"
                    :class="{
                      active: selectedMode === mode.id,
                    }"
                  ></div>
                </div>
                <div class="mode-info">
                  <strong>{{ mode.titre }}</strong
                  ><br />
                  <span>{{ mode.description }}</span>
                </div>
              </div>

              <div class="mode-right">
                <template v-if="mode.logos">
                  <div class="d-flex gap-2">
                    <img
                      v-for="(logo, index) in mode.logos"
                      :key="index"
                      :src="logo"
                      alt="logo"
                      class="logo-paiement"
                    />
                  </div>
                </template>

                <template v-else>
                  <div>{{ mode.iban }}</div>
                  <div>
                    <strong>{{ mode.banque }}</strong>
                  </div>
                </template>
              </div>
            </label>

            <div class="form-input">
              <label class="label-control"> Commentaire (facultatif) </label>
              <textarea class="form-control round-15" rows="3"></textarea>
            </div>

            <div class="form-input">
              <label>
                <input type="radio" /> J’accepte
                <a href="#">les conditions générales de vente</a>
                et
                <a href="#">les conditions d’annulation </a>
              </label>
            </div>

            <div class="row justify-content-center">
              <div class="col-lg-4">
                <div class="d-flex gap-3">
                  <img :src="ssl" />
                  <img :src="verfied" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Mode de paiement-->
      </div>
    </div>
  </div>
</template>

<script>
  import master from "@/assets/images/master-card.svg";
  import visa from "@/assets/images/visa.svg";
  import ssl from "@/assets/images/ssl-secure.svg";
  import verfied from "@/assets/images/Visa-verified.svg";
  import cb from "@/assets/images/cb.svg";
  import { ref } from "vue";
  // paiement
  const selectedMode = ref(1); // ID du mode sélectionné par défaut

  const modes = [
    {
      id: 1,
      titre: "Mode de paiement 1",
      description: "Mode de paiement",
      iban: "FR76 0000 3XXX X50X XXX0 2XXX XXX",
      banque: "SOCIÉTÉ GÉNÉRALE SA",
    },
    {
      id: 2,
      titre: "Mode de paiement 2",
      description: "Mode de paiement",
      iban: "FR76 0000 3XXX X50X XXX0 2XXX XXX",
      banque: "CRÉDIT AGRICOLE",
    },
    {
      id: 3,
      titre: "Mode de paiement 3",
      description: "Virement bancaire",
      iban: "",
      banque: "",
    },
    {
      id: 4,
      titre: "Mode de paiement 4",
      description: "Virement bancaire",
      logos: [master, visa, cb],
    },
  ];

  //point de relais
  const selectedPoint = ref(null);
  const pointsRelais = [
    {
      id: 1,
      nom: "L'ADRESSE SAINE",
      adresse: "25, Rue des Lilas, 75008 Paris, France",
      distance: 0.7,
      horaires: {
        Mardi: "09h - 19h",
        Mercredi: "09h - 19h",
        Jeudi: "09h - 19h",
        Vendredi: "09h - 19h",
        Samedi: "09h - 18h30",
      },
      map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2623.892239221515!2d2.3936289754130735!3d48.87933079923405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66dbebb86f29d%3A0x50feae08471a4d4d!2s25%20Rue%20des%20Lilas%2C%2075019%20Paris%2C%20France!5e0!3m2!1sfr!2stn!4v1747985663987!5m2!1sfr!2stn" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade',
    },
    {
      id: 2,
      nom: "AUTRE RELAIS",
      adresse: "12, Rue de Lyon, 75012 Paris, France",
      distance: 1.2,
      horaires: {
        Mardi: "10h - 18h",
        Mercredi: "10h - 18h",
        Jeudi: "10h - 18h",
        Vendredi: "10h - 18h",
        Samedi: "10h - 17h30",
      },
      map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2623.892239221515!2d2.3936289754130735!3d48.87933079923405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66dbebb86f29d%3A0x50feae08471a4d4d!2s25%20Rue%20des%20Lilas%2C%2075019%20Paris%2C%20France!5e0!3m2!1sfr!2stn!4v1747985663987!5m2!1sfr!2stn" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade',
    },
  ];
  export default {
    name: "LivraisonMode",
    data() {
      return {
        selectedPoint,
        pointsRelais,
        selectedMode,
        modes,
        ssl,
        verfied,
      };
    },
  };
</script>
